import { SVGProps } from 'react'

export const NePowerPointvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g fill='none' fillRule='evenodd'>
      <g>
        <path
          d='m14.438 1.5 6 6v12.75a2.25 2.25 0 0 1-2.25 2.25H5.813a2.25 2.25 0 0 1-2.25-2.25V3.75a2.25 2.25 0 0 1 2.25-2.25h8.625Zm-2.046 7.219H9.886l-.102.007a.75.75 0 0 0-.648.743v4.1l.002.054.005.053v3.555l.008.102a.75.75 0 0 0 1.493-.102l-.001-2.912h1.749l.17-.005a2.8 2.8 0 0 0-.17-5.595Zm0 1.5a1.3 1.3 0 0 1 1.3 1.3l-.007.133a1.3 1.3 0 0 1-1.293 1.167h-1.75v-2.6Z'
          fill='#DE5F31'
        />
        <path
          d='M14.438 1.5V6a1.5 1.5 0 0 0 1.5 1.5h4.5l-6-6Z'
          fill='#F0B7A2'
        />
      </g>
    </g>
  </svg>
)
